import { getMessages } from '../../../../../../../store/constants';

export const WATCH_TOOLTIP = getMessages().getText('card_form_watch_card');
export const WATCH_STOP_TOOLTIP = getMessages().getText('card_form_watch_card_stop');
export const WATCH_TOOLTIP_NOTIFICATIONS_OFF = getMessages().getText('card_form_watch_card_notifications_off');
export const WATCH_TEXT = 'Subscribe';
export const WATCH_TEXT_ACTIVE = 'Subscribed';
export const CHANGE_SETTINGS_TOOLTIP = getMessages().getText('card_form_watch_card_change_settings_tooltip');
export const CHANGE_SETTINGS_TOOLTIP_LINK = getMessages().getText('card_form_watch_card_change_settings_tooltip_link');
